<template>
    <div
        class="Link Link-wrapper"
        @click="onClick">
        <hempel-icon
            class="Link-icon"
            :name="icon"/>
        <span class="Link-label">{{ label }}</span>
    </div>
</template>
<script>
import HempelIcon from '@/components/shared/icon/Icon'

export default {
    name: 'HempelLink',
    props: {
        label: {
            type: String,
            required: true
        },
        icon: {
            type: String,
            required: true
        }
    },
    components: {
        HempelIcon
    },
    methods: {
        onClick(e) {
            this.$emit('click', e)
        }
    }
}
</script>
